import {useMutation, useQueryClient} from '@tanstack/react-query';
import recruitmentsFetchers from '@/api/fetchers/recruitments';
import type {
  BulkRequestVettingParams,
  BulkRequestVettingResponse,
} from '@/views/creators/recruit-crm/types';
import {recruitmentsQueryKey} from '@/hooks/queries/use-recruitments-query';

function useBulkRequestVetting() {
  const queryClient = useQueryClient();

  return useMutation<
    BulkRequestVettingResponse,
    Error,
    BulkRequestVettingParams
  >({
    mutationKey: [recruitmentsQueryKey, 'bulkRequestVetting'],
    mutationFn: recruitmentsFetchers.bulkRequestVetting,
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: [recruitmentsQueryKey]});
    },
  });
}

export default useBulkRequestVetting;
